// This an edited fontawesome "gem" icon, using https://aydos.com/svgedit/
// The gem is originally a single path, the tool broke the path
// into a path-per-gem-segment.
export const createDiamond = () => ({
    svgAttrs: {
        viewBox: '0 0 576 512',
    },
    flows: {
        circle: [[0], [1], [2], [3], [4], [5]],
        horizontal: [[0, 5], [1, 4], [2, 3]],
        // vertical: [[0, 1, 2], [3, 4, 5]], // doesn't look good
        diagonal: [[0], [1, 5], [2, 4], [3]],
        snake: [[0], [5], [4], [1], [2], [3]],
        random: 'random'
    },
    elements: [
        {
            fill: '#FFB870',
            pos: 'top left',
            order: 0,
            tag: 'path',
            d: 'M90.5 0H170.3L101.1 160H0L90.5 0Z'
        },
        {
            fill: '#FF9D3A',
            pos: 'top center',
            order: 1,
            tag: 'path',
            d: 'M357.5 0 426.7 160H149.3L218.5 0H357.5Z'
        },
        {
            fill: '#FFB870',
            pos: 'top right',
            order: 2,
            tag: 'path',
            d: 'M485.5 0 576 160H474.9L405.7 0H485.5Z'
        },
        {
            fill: '#FFA345',
            pos: 'bot right',
            order: 3,
            tag: 'path',
            d:
          'M352.3 443.7 475.3 192H576L357.3 446.9C355 449.6 350.8 446.8 352.3 443.7Z'
        },
        {
            fill: '#EA7600',
            pos: 'bot center',
            order: 4,
            tag: 'path',
            d:
          'M148.2 192H427.8L290.8 510.2C289.8 512.6 286.3 512.6 285.3 510.2L148.2 192Z'
        },
        {
            fill: '#FFA345',
            pos: 'bot left',
            order: 5,
            tag: 'path',
            d: 'M0 192H100.7L223.7 443.7C225.2 446.8 221 449.6 218.7 447L0 192Z'
        }
    ]
})
